document.addEventListener('variant:change', function(event) {
  const variant = event.detail?.variant;
  if (!variant) return;

  if (variant.title.toLowerCase().includes("custom")) {

    const phone = "918800793872"; // apna whatsapp number
    const message = encodeURIComponent(
      "Hi, I want to order a custom product: " + variant.title
    );

    window.open(`https://wa.me/${phone}?text=${message}`, "_blank");
  }
});